import { AxiosResponse, AxiosError } from 'axios'
import get from 'lodash.get'
import { ZodError } from 'zod'

class Extract {
  data = function <T = unknown>(
    response: AxiosResponse<T>
  ): Exclude<ApiResponseV2<T>, { status: 'error' }> {
    if (get(response, 'data.data', null)) {
      return {
        data: get(response, 'data.data'),
        error: undefined,
        status: 'ok'
      }
    }

    return {
      data: response.data,
      error: undefined,
      status: 'ok'
    }
  }

  error = function (
    error: AxiosError<{ description?: string; message?: string }> | ZodError
  ): Exclude<ApiResponseV2<unknown>, { status: 'ok' }> & { data: any } {
    if (error instanceof ZodError) {
      return {
        data: null,
        error: 'ZodError: Invalid Request.',
        status: 'error'
      }
    }

    return {
      data: null,
      error:
        error.response?.data?.message ??
        error.response?.data?.description ??
        error.message,
      status: 'error'
    }
  }
}

const extract = new Extract()

export default extract
